import { Injectable } from "@angular/core";
import { products } from '@app/constants/products';
import { ProductSubtypeEnum } from '@app/models/enums/product-subtype.enum';
import { ProductTypeEnum } from '@app/models/enums/product-type.enum';
import { ProductDetails } from '@app/models/interfaces/product-details.interface';
import { ProductSiteRegionService } from "@app/services/product-site-region.service";
import { TfWindowRefService } from '@app/modules/tf-window-ref';
import { TfUserDataService } from '@app/modules/tf-user-data';

@Injectable({providedIn: 'root'})
export class ProductsService {
    constructor(
        private productSiteRegionService: ProductSiteRegionService,
        private window: TfWindowRefService,
        private readonly userDataService: TfUserDataService,
    ) {
    }
    getProduct(productType: ProductTypeEnum, productSubType: ProductSubtypeEnum): ProductDetails | undefined {

        return products.find((product) => {
            return product.productType === productType && product.productSubType === productSubType;
        });

    }

    isUserTypeB2B(): boolean {

        if (this.productSiteRegionService.isThermofisher()){
            return this.userDataService.user?.userType === 'b2b';
        } else {
            return this.window.nativeWindow?.env?.userIsPunchOut || false;
        }

    }

}
